const $ = window.jQuery;

import _ from 'lodash';

$(() => {
    const $accordions = $('.offscreen-menu__primary > .menu-item > .sub-menu');

    if (!$accordions.length) {
        return;
    }

    _.each($accordions, accordion => {
        const $accordion = $(accordion);
        const $items = $accordion.children();
        let accordion_height = 0;
        _.each($items, item => {
            accordion_height += $(item).outerHeight(true);
        });
        $accordion.attr('data-max-height', accordion_height);
    });

    const $menu = $('#offscreen-menu');
    const $overlay = $('#offscreen-menu-overlay');
    const $menu_primary_top_items = $('.offscreen-menu__primary > .menu-item');

    _.each($menu_primary_top_items, item => {
        const $item = $(item);
        const $link = $item.children('a').first();
        const link_text = $link.text();
        $link.html(`<span>${link_text}</span>`);

        $item.on('click', function(e) {
            if (!$(e.target).is('a')) {
                const $sub_menu = $(this)
                    .children('.sub-menu')
                    .first();
                if (!$(this).hasClass('menu-item--active')) {
                    $(this).addClass('menu-item--active');
                    const menuMaxHeight = $sub_menu.attr('data-max-height');
                    const maxHeight = `${menuMaxHeight}px`;
                    const transition = `max-height ${menuMaxHeight *
                        3}ms cubic-bezier(0.47, 0, 0.745, 0.715)`;
                    $sub_menu.css({ transition, maxHeight });
                } else {
                    $(this).removeClass('menu-item--active');
                    $sub_menu.css({ maxHeight: 0 });
                }
            }
        });

        $item.children('a').first().hover( function(e) {
            $item.addClass('menu-item--text-hover');
        }, function(e) {
            $item.removeClass('menu-item--text-hover');
        });
    });

    $('[data-toggle-menu]').on('click', e => {
        e.preventDefault();
        if (!$menu.hasClass('offscreen-menu--active')) {
            $overlay.addClass(
                'offscreen-menu--overlay--active animated fadeIn',
            );
            $overlay.one('animationend', () => {
                $overlay.removeClass('animated fadeIn');
            });
            $menu.addClass('offscreen-menu--active animated fadeInLeftBig');
            $menu.one('animationend', () => {
                $menu.removeClass('animated fadeInLeftBig');
            });
        } else {
            $menu.addClass('animated fadeOutLeftBig');
            $menu.one('animationend', () => {
                $menu.removeClass(
                    'offscreen-menu--active  animated fadeOutLeftBig',
                );
            });
            $overlay.addClass('animated fadeOut');
            $overlay.one('animationend', () => {
                $overlay.removeClass(
                    'offscreen-menu--overlay--active animated fadeOut',
                );
            });
        }
    });
});
